<div class="step-card">
  <div class="step-cart__header">
    <mat-icon svgIcon="{{ svgIcon() }}" class="step-card__icon"></mat-icon>
  </div>
  <div class="step-card__content">
    <div class="step-card__text">
      <div class="heading-xs step-card__title">
        {{ title() }}
      </div>
      <div class="body-s step-card__description">
        {{ description() }}
      </div>
    </div>
    <app-button
      type="tertiary"
      size="small"
      icon="north_east"
      text="{{ textLink() }}"
      routerLink="{{ urlLink() }}">
    </app-button>
  </div>
</div>
